const initialState = {
    loggedUser: {},
    pending: false,
    users: [],
    allUsers: [],
    customUsers: [],
    usersForAccessTable: [],
    usersForAccessTableFilterOptions: null,
    usersForAccessTableFilters: {page: 1, numberOnPage: 9999, search: '', onlyGCUsers: false, },
    selectedUatUser: null,
    lastInvoiceData: null,
    page: 0,
    userCount: 0,
    pageCount: 0,
    error: null,
    selected: {},
    filtered: {},
    userModules: [],
    modulesPending: false
};

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_LOGGED_USER':
            return {
                ...state,
                loggedUser: action.user
            };
        case 'GET_USERS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_MODULES_PENDING':
            return {
                ...state,
                modulesPending: true
            };
        case 'GET_USERS_SUCCESS':
            return {
                ...state,
                pending: false,
                users: action.users,
                page: action.page,
                pageCount: action.pageCount,
                userCount: action.userCount
            };
        case 'GET_MODULES_ERROR':
            return {
                ...state,
                modulesPending: false,
                error: action.payload
            };
        case 'GET_USER_MODULES_SUCCESS':
            return {
                ...state,
                modulesPending: false,
                userModules: action.payload,
                error: null
            };
        case 'GET_ALL_USERS_SUCCESS':
            return {
                ...state,
                pending: false,
                allUsers: action.users
            };
        case 'GET_ALL_CUSTOM_USERS_SUCCESS':
            return {
                ...state,
                pending: false,
                customUsers: action.users
            };
        case 'GET_USERS_FOR_ACCESS_TABLE_SUCCESS':
            return {
                ...state,
                pending: false,
                usersForAccessTable: action.users
            };
        case 'GET_USERS_ACCESS_TABLE_FILTER_OPTIONS':
            return {
                ...state,
                pending: false,
                usersForAccessTableFilterOptions: action.filters
            };
        case 'SET_USERS_ACCESS_TABLE_FILTERS':
            return {
                ...state,
                usersForAccessTableFilters: action.filters
            };
        case 'SELECT_USERS_ACCESS_TABLE_USER':
            return {
                ...state,
                selectedUatUser: action.uatUser
            };
        case 'SELECT_USER_INVOICE':
            return {
                ...state,
                selectedInvoice: action.selectedInvoice
            };
        case 'ADD_INVOICE_SUCCESS':
            return {
                ...state,
            };
        case 'GET_LAST_INVOICE_DATA_SUCCESS':
            return {
                ...state,
                pending: false,
                lastInvoiceData: action.lastInvoiceData
            };
        case 'GET_USERS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_USER':
            return {
                ...state,
                selected: action.selected
            };
        case 'FILTER_USER':
            return {
                ...state,
                filtered: action.user
            };
        case 'ADD_USER_SUCCESS':
            return {
                ...state,
                pending: false
            };
        case 'ADD_USER_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'ACTIVATE_MODULE_PENDING':
            return {
                ...state,
                modulesPending: true,
                error: null
            };

        case 'ACTIVATE_MODULE_SUCCESS':
        case 'DEACTIVATE_MODULE_SUCCESS':
            return {
                ...state,
                modulesPending: false,
                error: null
            };
        case 'ACTIVATE_MODULE_ERROR':
        case 'DEACTIVATE_MODULE_ERROR':
            return {
                ...state,
                modulesPending: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default usersReducer;
